import { FontSize } from '@tiptap/extension-text-style';
import { menuStatusFor } from './_get_menu_control';
import { fontSizeUnderCursor } from './_font_size_helpers';

const syncMenu = ({ editor }) => {
  const fontSize = editor.getAttributes('textStyle').fontSize || fontSizeUnderCursor(editor);
  const intFontSize = parseInt(fontSize, 10);
  const menuStatus = menuStatusFor(editor, 'font:size:set');

  menuStatus?.setAttribute('data-menu-status-selected-value', intFontSize);
};

export default [
  FontSize.extend({
    onCreate: syncMenu,
    onSelectionUpdate: syncMenu,
    onTransaction: syncMenu,
  }),
];
